<template>
  <div style="width: 100%">
    <table class="ui striped selectable table">
      <thead>
        <tr>
          <th>#</th>
          <th v-if="showSchool">School</th>
          <th v-if="!hideDetails">Period</th>
          <th v-if="!hideDetails">Student count</th>
          <th v-if="!hideDetails">Type</th>
          <th>Cost (inc VAT)</th>
          <th v-if="!showPaidDate">Due on</th>
          <th>Paid</th>
          <th v-if="showPaidDate">Paid on</th>
          <th v-if="!showPaidDate">Remaining balance</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!licenses || licenses.length == 0">
          <td></td>
          <td colspan="4">No invoices found</td>
        </tr>
        <invoice-table-row v-for="license in licenses" v-bind:license="license" v-bind:key="license.Id"
          v-bind:actions="actions" v-on:action="rowAction" v-bind:showSchool="showSchool"
          v-bind:showPaidDate="showPaidDate" v-bind:hide-details="hideDetails" />
      </tbody>
    </table>
  </div>
</template>

<script>
import InvoiceTableRow from '@/components/invoices/InvoiceTableRow';

export default {
  name: 'InvoicesTable',
  computed: {},
  components: { InvoiceTableRow },
  props: ['licenses', 'actions', 'showSchool', 'showPaidDate', 'hideDetails'],
  methods: {
    rowAction(action) {
      this.$emit('rowAction', action);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/invoices/InvoicesTable.vue